import { isImpersonating } from '../../utils/cache/utils';

export function useImpersonationBanner() {
	return {
		showImpersonationBanner: isImpersonating(),
	};
}
